import DownloadMatchProvider from "context/downloadMatch/provider";
import HighlightCreationProvider from "context/HighlightCreation/provider";
import OCRProvider from "context/ocr/provider";
import SocialMediaPublishProvider from "context/socialMediaPublishStatus/provider";
import TransformVideosProvider from "context/transformVideos/provider";

const MainContextProvider = ({ children }) => {
  return (
    <SocialMediaPublishProvider>
      <HighlightCreationProvider>
        <DownloadMatchProvider>
          <TransformVideosProvider>
            <OCRProvider>{children}</OCRProvider>
          </TransformVideosProvider>
        </DownloadMatchProvider>
      </HighlightCreationProvider>
    </SocialMediaPublishProvider>
  );
};

export default MainContextProvider;
